// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vx-8";
export var editMode = "_vx-3";
export var headerRow = "_vx-a";
export var headerTitle = "_vx-b";
export var product = "_vx-1";
export var productDetails = "_vx-5";
export var productDivider = "_vx-7";
export var productImage = "_vx-2";
export var productInfo = "_vx-4";
export var productTitle = "_vx-6";
export var strikethrough = "_vx-9";
export var upsellProductsCard = "_vx-0";